import { useFlagshipFlag } from '../../helpers/useFlagshipFlag';
import { NEW_CONSENT_FLOW } from '../experiments.constants';

export const useIsNewConsentFlowExperiment = (visitorExposed: boolean) =>
  useFlagshipFlag({
    key: NEW_CONSENT_FLOW,
    defaultValue: undefined,
    visitorExposed: visitorExposed,
  });
